import React, { Component, Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import shop from "shop/shop"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea,Image} from "semantic-ui-react"
import queryString from "qs"
import ProductTable from "components/Product/ProductTableReturn"
import CartTotal from "components/Cart/CartTotal"
import Responsive from "react-responsive"
import { Link } from "react-router-dom"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import searchStore                 from "stores/searchStore"
import _ from "lodash"
import productStore from "stores/productStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import Spinner                              from "components/Spinner/Spinner"
import moment                               from "moment"
import {
	Card,
	Col,
	EmailInputGroup,
	FormField,
	FormInput,
	Row,Table
  } from "elemental-react16"
class ReturnPageQuantity extends Component {
    state = {
        product: false,
        primaryImage: false,
        products: getProducts(),
        frachtkosten: true,
        productsTemp: [],
        navHeader: false,
        searchString: "",
        productSearch: getProducts(),
        quantityPackages: 0,
        generatePDF: false,
        loadCart: true, 
        newSeason: {
            season: {
                seasonActive: false,
                referenceNumber: "",
                email: "",
                start: "",
                end: "",
                name: ""
            }
        }
      }

      componentDidMount() {
        console.log("DATA MOUNT PLS")
        shop.cart.hooks.changed.add( this.updateCart )
        shop.cart.hydrate()
        shop.cart.update()
        this.handleFetchDate()
        this.handleSetInventoryOrder()
        /*if(!shop.delivery){
          console.log("shop.delivery is empty")
          this.props.history.push("/return")
        }*/
      }
      
      handleChange = ( { product } ) => {
        //console.log("HANDLE CHANGE PRODUCT: ", product)
        shop.cart.add( product )
      }

      handleSetInventoryOrder = async () => {
        await shop.cart.setExtra( "ts-ordertype", "inventory" )
        await shop.cart.setExtra( "ts-ordertype-02", "inventoryPackages" )
      }

      handleFetchDate = async () => {
        console.log("DATA handleFetchDate")
        try {
        const response = await shop.fetch('/shop/rest/config/?set=' + encodeURIComponent(JSON.stringify(["web.kv.saison","web.kv.start","web.kv.end", "web.kv.id"])), {
            method: 'GET',
            credentials: 'include'
        });
        console.log("DATA: ", response);
        const seasonName = await shop.cart.getExtra("seasonName")
        console.log("SEASON NAME: ", seasonName)
        const data = await response
        const startDates = data["web.kv.start"].split(",");
        const endDates = data["web.kv.end"].split(",");
        const seasonIds = data["web.kv.id"].split(",");
        const names = decodeURIComponent(data["web.kv.saison"]).split(",");
        const today = new Date();
        const seasons = {};
        for (let i = 0; i < names.length; i++) {
            if (startDates[i] !== "" && endDates[i] !== "" && names[i] !== "") {
                const startDate = moment(startDates[i], "DD.MM.YYYY").toDate();
                const endDate = moment(endDates[i], "DD.MM.YYYY").toDate();
                if (today >= startDate && today <= moment(endDate).add(1, 'days').toDate()) {
                    this.setState({seasonActive: true})
                    seasons[names[i]] = {
                        start: startDates[i],
                        end: endDates[i],
                        name: names[i],
                        id: seasonIds[i],
                        seasonActive: true,
                        returnActive: false
                            };
                }
                else{
                    seasons[names[i]] = {
                        start: startDates[i],
                        end: endDates[i],
                        name: names[i],
                        id: seasonIds[i],
                        seasonActive: false,
                        returnActive: false
                        };
                }

            }
        }
        this.setState({
            newSeason: {
            season: {
            start: startDates[0],
            end: endDates[0],
            name: seasonName,
            id: seasonIds[0],
            },
            seasons: seasons
            }
        });
        
        console.log("DATA POST: ", this.state.newSeason);
        this.setState({loading: false})
        } catch (error) {
        console.error('Error fetching date:', error);
        }
    }

      loadProduct( id ) {
		if ( this.id === id ) return
		this.id = id
		productStore.get( id )
			.then( product => {
                if(!product){
                    return false
                }
				product.count = this.state.quantityPackages
                product.count++
				let inCart = shop.cart.productsById.get( product.map_id )
                console.log("product RETURN",product)
                shop.cart.add( product )
				if ( inCart ) product.count = Number( inCart.count )
				shop.analytics.push( product.map_id )
				this.setState( {product: product, primaryImage: false} )
                console.log("shop.cart",shop.cart)
				if ( !product.mainart ) return
				productStore.partlist( product.mainart , true )
					.then( variants => {
						if ( !variants ) {
							console.error( "ProductPage: Keine Varianten gefunden ", {product} )
							return
						}
						const variantProtoypeByKey = {}

						let byAttribute = {}
						let variantMap = {}
						variants.variants.varfields.forEach( varfield => {

							let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
							var ordered = {};
							// TODO: UNIFY
							_( categories ).keys().sort(
								( a, b ) => {
									let s0 = ordinals[a]
									let s1 = ordinals[b]
									return s0 >= s1 ? 1 : -1
								}
							).each( function ( key ) {
								ordered[key] = categories[key];
							} );
							byAttribute[varfield] = ordered
						} )

						let count = 0
						variants.products.forEach( product => {
							if ( !product.available ) return
							count++
							const hash = variants.variants.varfields
								.map( varfield => {
									const bucket = variantProtoypeByKey[varfield] || {}
									if ( !bucket[product.extraValue[varfield]] ) {
										bucket[product.extraValue[varfield]] = product
									}
									variantProtoypeByKey[varfield] = bucket

									return product.extraValue[varfield] || "null"
								} )
								.join( "___" )

							variantMap[hash] = product
						} )

						//console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
						this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
					} )
			} )
			.catch( error => {
				this.setState( {error} )
			} )
	}
      
      updateCart = () => {
        let products = getProducts()
        products = getProducts()
        this.setState( { products } )
        this.forceUpdate()
      }
      
      componentWillUnmount() {
        this.setState({productsTemp: shop.cart.products})
        shop.cart.hooks.changed.remove( this.updateCart )
      }

    render() {
        const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
        let { products, productSearch, loadCart } = this.state
        //console.log("SHOP RETURN: ", shop.return)
        const { loading } = shop.cart
        if (loadCart) {
            setTimeout(() => {
                this.setState({ loadCart: false });
            }, 500);
            return <div className="pa4 tc">
                    <Spinner size="md" type="inverted"/></div>
        }
        let seasonNameInCart = shop.cart.getExtra( "seasonName" )

        const handleChange = (event) => {
            console.log("CHANGE: ", event.target)
            let tempname = event.target.name
            let tempname2 = event.target.className
            let tempvalue = event.target.value
            this.setState(prevState => {
              let newSeason = { ...prevState.newSeason };  
              newSeason[tempname][tempname2] = tempvalue;       
              return { newSeason }; 
              })
            }; 
            
        const handleSendMail = () => {
            console.log("SEND MAIL: ", this.state.newSeason)
            shop.toast("Ihre PDF wird generiert.")
            const isValidEmail = (email) => {
                // Regular expression to validate email format
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(email);
            };

            if (!isValidEmail(this.state.newSeason.season.email)) {
                shop.toast("Invalid email address");
                return;
            }
            // Continue with sending the email
            const sendPDFEmail = async (pdfBlob) => {
                const formData = new FormData();
                formData.append('email', this.state.newSeason.season.email);
                formData.append('pdf', pdfBlob, 'pakete.pdf');

                try {
                    const response = await fetch(`${shop.config.API}send-email`, {
                        method: 'POST',
                        credentials: 'include',
                        body: formData
                    });

                    if (response.ok) {
                        shop.toast("PDF wurde per E-Mail gesendet.");
                    } else {
                        shop.toast("Fehler beim Senden der E-Mail.");
                    }
                } catch (error) {
                    shop.toast("Fehler beim Senden der E-Mail.");
                    console.error('Error sending email:', error);
                }
            };

            fetch(`${shop.config.API}reports/create?template=PaketBarcodes`, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify({
                    customer: shop.session.shopuser.customer,
                    count: this.state.quantityPackages,
                })
            })
            .then(response => {
                response.json().then(data => {
                    console.log("RESPONSE DATA: ", data);
                    const rid = data.rid;
                    fetch(`${shop.config.API}reports/load/pakete.pdf?rid=${rid}`, {
                        method: "GET",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/pdf"
                        }
                    })
                    .then(responsePDF => responsePDF.blob())
                    .then(blob => {
                        console.log("BLOB: ", blob);
                        const url = URL.createObjectURL(blob);
                        console.log("URL: ", url);
                        window.open(url, "_blank");
                        sendPDFEmail(blob); // Send the PDF via email
                    })
                    .catch(error => {
                        shop.toast("Fehler beim anzeigen der PDF.");
                        // Handle the error
                    });
                }).catch(error => {
                    shop.toast("Fehler beim Verarbeiten der Antwort.");
                    // Handle the error
                });
            })
            .catch(error => {
                shop.toast("Fehler beim generieren der PDF.");
                // Handle the error
            });
        }

        const handleSendReturn  = async () => {
            console.log("SEND RETURN: ", this.state.newSeason)
            this.loadProduct("123456")
            const delay = ms => new Promise(
                resolve => setTimeout(resolve, ms)
              );
            shop.toast("Ihre Retoure wird bestätigt.")
            await shop.cart.setExtra( "ts-ordertype", "inventory" )
            await shop.cart.setExtra( "ts-ordertype-02", "inventoryPackages" )
            await shop.cart.setExtra( "kartons_all", this.state.quantityPackages )
            await shop.cart.setExtra( "referenceId", this.state.newSeason.season.referenceNumber )
            await delay(1000);
            //console.log("RETURN CURRENT CART: ", shop.cart)
            shop.cart.hooks.changed.add( this.updateCart )
            shop.cart.hydrate()
            shop.cart.update()
            //console.log("FINAL CART CONFIRMATION2: ", shop.cart)
            
    
            //this.props.history.push( "/return/success" )
        }

        const handleChangeQuantityPackages = (event) => {
            if(event.target.value > 1000){
                shop.toast("Maximal 1000 Pakete pro Saison")

            }
            else{
                this.setState({ quantityPackages: event.target.value });
                if(event.target.value > 0){
                    this.setState({ generatePDF: true });
                }
                else{
                    this.setState({ generatePDF: false });
                }
                console.log("QUANTITY PACKAGES: ", event.target.value, this.state.quantityPackages)

            }

        };

        return (
            <Fragment>
                {<Responsive minWidth={790} >
                <div>
                <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="70%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <Row style={{width: "81%"}} className="pt3 pb3">
                                <Col sm="3/16">
                                <Image src={"/BH_logo_lang.svg"} alt="TEST" />
                                </Col>

                                <Col sm="10/16">
                                <h1 style={{color:"#265a88", fontSize:30}}  className="pt2 tc"><b>Anmeldung Pakete</b></h1>
                                </Col>
                                <Col sm="3/16" className="pt2 pl2 tr">
                                    <div className="tr"><Button primary className="mt4" onClick={() => this.props.history.push("/logout")}><Icon name={"power off"}/>Abmelden</Button></div>
                                    
                                </Col>
                            </Row>

                            <Message style={{width: "80%"}}>
                            <div className="f4 fw7">{translate( "Bitte tragen Sie die Anzahl der Pakete in die untenstehende Erfassungsmaske ein.")}</div>
                            </Message>
                            <Message className="ui negative message" style={{width: "80%"}}>
                                <div className="f4 fw7"><Icon className="warning circle"></Icon>
                                {translate( `Es können nur Waren aus der aktuellen Saison ${seasonNameInCart} gutgeschrieben werden. Fälschlicherweise zugesendete Artikel aus vorherigen Saisons können nicht von uns zurückgesendet werden. `)}</div>
                            </Message>
                            <Message className="ui negative message" style={{width: "80%"}}>
                                <div className="f4 fw7"><Icon className="warning circle"></Icon>
                                {translate( "Pakete ohne Barcodes werden nicht gutgeschrieben.")}</div>
                            </Message>
                            {/*<Message className="ui negative message" style={{width: "80%"}}>
                                <div className="f4 fw7"><Icon className="warning circle"></Icon>
                                {translate( "Bitte beachten Sie, dass pro Saison nur ein Abholauftrag aufgegeben werden kann.")}</div>
                            </Message>*/}
                            <br/>
                            <div className="ba b--black-20 pa3 shadow-3" style={{width: "80%", backgroundColor:"#FAFAFA"}}>
                            <div className="pb2 pt3">
                            <b>1. Geben Sie die Anzahl der Pakete ein.</b>
                            </div>
                            <div className=" pl3 pb3 pt3 bb b--black-20 ">
                            <FormInput primary
                                style={{ width: "24%" }}
                                className={"bb b--black-10"}
                                value={this.state.quantityPackages}
                                onChange={handleChangeQuantityPackages}  placeholder={translate( "Anzahl Pakete ...")}>
                            </FormInput>
                            <Form className="pt3 pb2 ">
                            Geben Sie Ihre Retournummer ein (falls vorhanden).<br/>
                            Referenznummer mit Saison inkl. Jahr vorbelegen  
                                <Form.Group >
                                <Form.Input width={4} >
                                    <input fluid value={this.state.newSeason.season.referenceNumber} onChange={handleChange} className="referenceNumber" name="season" label="Referenznummer:" placeholder={translate("Referenznummer")}  /></Form.Input>
                                </Form.Group>
                            </Form>
                            </div>


                            <div className="pb2 pt4 fw5 ">
                            2. Schließen Sie die Paketanmeldung ab. <u className="fw7 ">Die Barcodes können nach der Bestätigung ausgedruckt werden.</u> Der DPD-Abholauftrag wird automatisch erzeugt. Der Fahrer bringt die Paketlabel zur Abholung mit. Bei Änderungen / Fragestellungen melden Sie sich bitte bei der Ihnen bekannten Kontaktperson im Vertriebsinnendienst.
                            </div>
                            <div className="pb3 pt3 pl3  ">
                                <Button className="shadow-3" disabled={!this.state.generatePDF}  primary
                                onClick={handleSendReturn}
                                >Paketaufgabe abschließen</Button>
                            </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </div>
                </Responsive>}    
                {<Responsive maxWidth={789} >
                <table className="pr2">
                <colgroup>
                </colgroup>
                <tbody>
                    <tr className="bb b--black-10">

                        </tr>
                        <tr className="tc">
                        <td className="tc pr2  pl2 v-top ReturnPageAlignment" >
                        {/*<td className="pr4  pl4 v-top ReturnPageAlignment" >
                            
                        </td>*/}
                        <div className="tr"><Button primary className="mt4" onClick={() => this.props.history.push("/logout")}><Icon name={"power off"}/>Abmelden</Button></div>
                        <Row className="pt2 pb2">
                                <Col sm="3/16">
                                
                                </Col>
                                <Col sm="10/16">
                                <Image src={"/BH_logo_lang.svg"} alt="BraunsHeitmann" />
                                </Col>
                                <Col sm="3/16">
                                </Col>
                            </Row>
                            <h1 style={{color:"#265a88", fontSize:40}}  className="tc"><b>Anmeldung Pakete</b></h1>

                            <Message >
                            <div className="f4 fw7">{translate( "Bitte tragen Sie die Anzahl der Pakete in die untenstehende Erfassungsmaske ein.")}</div>
                            </Message>
                            <Message className="ui negative message" >
                                <div className="f4 fw7"><Icon className="warning circle"></Icon>
                                {translate( `Es können nur Waren aus der aktuellen Saison ${seasonNameInCart} gutgeschrieben werden. Fälschlicherweise zugesendete Artikel aus vorherigen Saisons können nicht von uns zurückgesendet werden. `)}</div>
                            </Message>
                            <Message className="ui negative message" >
                                <div className="f4 fw7"><Icon className="warning circle"></Icon>
                                {translate( "Pakete ohne Barcodes werden nicht gutgeschrieben.")}</div>
                            </Message>
                            {/*<Message className="ui negative message" >
                                <div className="f4 fw7"><Icon className="warning circle"></Icon>
                                {translate( "Bitte beachten Sie, dass pro Saison nur ein Abholauftrag aufgegeben werden kann.")}</div>
                            </Message> */}
                            <br/>
                            <div className="ba b--black-20 pa3 shadow-3" style={{ backgroundColor:"#FAFAFA"}}>
                            <div className="pb2 pt3">
                            <b>1. Geben Sie die Anzahl der Pakete ein.</b>
                            </div>
                            <div className=" pl3 pb3 pt3 bb b--black-20 tc  ">
                            <FormInput primary
                                style={{ width: "40%", margin: "auto",align: "center" }}
                                className="tc"
                                value={this.state.quantityPackages}
                                onChange={handleChangeQuantityPackages}  placeholder={translate( "Anzahl Pakete ...")}>
                            </FormInput>
                            <Form className="pt3 pb2 ">
                                <Form.Group >
                                <Form.Input width={4} >
                                    <input fluid value={this.state.newSeason.season.referenceNumber} onChange={handleChange} className="referenceNumber" name="season" label="Referenznummer:" placeholder={translate("Referenznummer")}  /></Form.Input>
                                </Form.Group>
                            </Form>
                            </div>
                            {/*<div className="pb2 pt4">
                                <b>2. Drucken Sie die erzeugte PDF aus.</b>
                            </div>
                            <div className="pl3 pb3 pt3 bb b--black-20  ">
                                <table>
                                    <colgroup>
                                    </colgroup>
                                    <tr className="bb b-black-10">
                                        <td className="tc"> 
                                        <Button 
                                            onClick={handleGeneratePDF} primary>PDF anzeigen</Button>
                                        </td>
                                        
                                    </tr>
                                    <tr>
                                        <td>
                                        <Form className="pt2 pb2">
                                            <Form.Group >
                                            <Form.Input width={4} ><input fluid value={this.state.newSeason.season.email} onChange={handleChange} className="email" name="season" label="E-Mail:" placeholder={translate("E-Mail")}  /></Form.Input>
                                            </Form.Group>
                                        </Form>
                                        </td>
                                        <td>
                                        <Button 
                                            onClick={handleSendMail} primary>PDF senden</Button>
                                        </td>
                                    </tr>
                                </table>
                                </div>*/}
                            <div className="pb2 pt4 fw5 ">
                            2. Schließen Sie die Paketanmeldung ab. <u className="fw7 ">Die Barcodes können nach der Bestätigung ausgedruckt werden.</u> Der DPD-Abholauftrag wird automatisch erzeugt. Der Fahrer bringt die Paketlabel zur Abholung mit. Bei Änderungen / Fragestellungen melden Sie sich bitte bei der Ihnen bekannten Kontaktperson im Vertriebsinnendienst.
                            </div>
                            <div className="pb3 pt3 pl3  ">
                                <Button className="shadow-3"  primary disabled={!this.state.generatePDF}
                                onClick={handleSendReturn}
                                >Paketaufgabe abschließen</Button>
                            </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </Responsive>}
            </Fragment>
        );
    }
}

const getProducts = () => shop.cart.map( ( product ) => product)

export default ReturnPageQuantity;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/pages/returnCheckout/ReturnPageQuantity.js